import React, { Component } from "react";
import _ from "lodash";
import moment from "moment";
import PropTypes from "prop-types";
import Select from "@material-ui/core/Select";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import http from "../../util/http";
import { SingleDatePicker } from "react-dates";
import "react-dates/initialize";
import GameScoreResult from "./GameScoreResult";
import { MuiThemeProvider } from "@material-ui/core/styles";
import aceTheme from "../../util/aceTheme";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 0,
    padding: 0,
  },
  button: {
    margin: theme.spacing.unit,
  },
  progressLinear: {
    width: "100%",
    height: 5,
  },
});

const calculateHourLabel = (hr, start) => {
  let hourLabel = "";
  if (hr <= 12) {
    hourLabel = `${hr}:${start ? "00" : "59"} AM`;
  }
  if (hr > 12) {
    hourLabel = `${hr - 12}:${start ? "00" : "59"} PM`;
  }
  if (hourLabel === "0:59 AM") {
    hourLabel = "12:59 AM";
  }
  if (hourLabel === "0:00 AM") {
    hourLabel = "12:00 AM";
  }
  return hourLabel;
};

const generateDayOptions = (start) =>
  _.times(24, (i) => <option value={i}>{calculateHourLabel(i, start)}</option>);

class GameScoreReportForm extends Component {
  state = {
    startHour: 0,
    endHour: 24,
    reasonVoid: "Perform a Search",
    searchingScore: false,
    periodList: [],
    typeList: [],
    gameScoreData: [],
    scoreReportDate: moment(),
    focused: false,
    type: 0,
  };
  changeHour = (hour) => (event) => {
    this.setState({ [hour]: event.target.value });
  };
  handleChange = (event) => {
    this.setState({ name: event.target.value });
  };
  handlePeriodChange = (event) => {
    this.setState({ periodList: event.target.value });
  };
  handleTypeChange = (event) => {
    this.setState({ typeList: event.target.value });
  };
  searchScoreReport = async () => {
    try {
      const { prmIdAgent } = this.props;
      const { scoreReportDate, startHour, endHour, type } = this.state;
      const scoreReportDateCloned = scoreReportDate.clone();
      const scoreReportDateEndCloned = scoreReportDate.clone();
      const formattedStartDay = scoreReportDateCloned.format("YYYY-MM-DD");
      // doing this because the stored procedure adds 1 day to the end date;
      const formattedEndDay = scoreReportDateEndCloned
        .add(-1, "day")
        .format("YYYY-MM-DD");
      this.setState({
        reasonVoid: "Searching...",
        searchingScore: true,
        gameScoreData: [],
      });
      const payloadGameScore = JSON.stringify({
        idUser: prmIdAgent,
        startDate: `${formattedStartDay} ${startHour}:00:00.000`,
        endDate: `${formattedEndDay} ${endHour}:59:59.999`,
        type, //0 = game date, 1 graded date
      });
      const gameScoreData = await http.sendHelperCommand(
        "GameScoreHelper.aspx",
        { payload: payloadGameScore }
      );
      const mergedScoreData = _.merge(
        _.keyBy(gameScoreData.ScoreData, "IdGame"),
        _.keyBy(gameScoreData.GameValueData, "IdGame")
      );
      const mergedData = _.values(mergedScoreData);
      this.setState({
        reasonVoid: "Data not found",
        gameScoreData: mergedData,
        searchingScore: false,
      });
    } catch (err) {
      this.setState({
        reasonVoid: err.message,
        gameScoreData: [],
        searchingScore: false,
      });
    }
  };
  render() {
    const { classes } = this.props;
    return (
      <MuiThemeProvider theme={aceTheme}>
        <div className={classes.container}>
          <form autoComplete="off">
            <FormControl className={classes.formControl} style={{ width: 200 }}>
              <SingleDatePicker
                isOutsideRange={() => false}
                date={this.state.scoreReportDate}
                onDateChange={(scoreReportDate) =>
                  this.setState({ scoreReportDate })
                }
                focused={this.state.focused}
                onFocusChange={({ focused }) => this.setState({ focused })}
              />
            </FormControl>
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="age-native-simple">Start Hour</InputLabel>
              <Select
                native
                value={this.state.startHour}
                onChange={this.changeHour("startHour")}
                inputProps={{
                  id: "age-native-simple",
                }}
              >
                {generateDayOptions(true)}
              </Select>
            </FormControl>
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="age-native-simple">End Hour</InputLabel>
              <Select
                native
                value={this.state.endHour}
                onChange={this.changeHour("endHour")}
                inputProps={{
                  id: "age-native-simple",
                }}
              >
                {generateDayOptions(false)}
              </Select>
            </FormControl>
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="age-native-simple">Range By</InputLabel>
              <Select
                native
                value={this.state.type}
                onChange={this.changeHour("type")}
                inputProps={{
                  id: "age-native-simple",
                }}
              >
                <option value={0}>Game Date</option>
                <option value={1}>Graded Date</option>
              </Select>
            </FormControl>
            <FormControl>
              <Button
                color="primary"
                variant="contained"
                onClick={this.searchScoreReport}
              >
                Search
              </Button>
            </FormControl>
          </form>
          {this.state.searchingScore && (
            <LinearProgress className={classes.progressLinear} />
          )}
          <GameScoreResult
            {...{
              gameScoreData: this.state.gameScoreData,
              reasonVoid: this.state.reasonVoid,
            }}
          />
        </div>
      </MuiThemeProvider>
    );
  }
}

GameScoreReportForm.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  prmIdAgent: PropTypes.string.isRequired,
};

export default withStyles(styles, { withTheme: true })(GameScoreReportForm);
